module.exports = __webpack_public_path__ + "img/pic12.39260510.jpg";